import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { accommodationSearchExecutor, apiKey } from '@custom/campingcare';
import {
  AccommodationSearchQuery,
  AllAccommodationAttributesQuery,
  AllAccommodationTypeTermsQuery,
  AllCampsiteFeaturesQuery,
  AllCampsiteRegionsQuery,
  AllCampsitesQuery,
  FrameQuery,
  OperationExecutorsProvider,
  SearchPageSettingsQuery,
} from '@custom/schema';
import { Frame } from '@custom/ui/routes/Frame';
import React, { PropsWithChildren } from 'react';

import { useAccommodationAttributes } from '../queries/accommodation-attributes';
import { useAccommodationTypeTerms } from '../queries/accommodation-type-terms';
import { useAllCampsiteFeatures } from '../queries/campsite-features';
import { useAllCampsiteRegions } from '../queries/campsite-regions';
import { useAllCampsites } from '../queries/campsites';
import { useSearchPageSettings } from '../queries/search-page';
import { drupalExecutor } from '../utils/drupal-executor';

export default function Layout({
  children,
}: PropsWithChildren<{
  locale: string;
}>) {
  const data = useStaticQuery(graphql(FrameQuery));
  const allAccommodationAttributes = useAccommodationAttributes();
  const allAccommodationTypeTerms = useAccommodationTypeTerms();
  const allCampsites = useAllCampsites();
  const allCampsitesRegions = useAllCampsiteRegions();
  const searchPageSettings = useSearchPageSettings();
  const allCampsiteFeatures = useAllCampsiteFeatures();
  return (
    <OperationExecutorsProvider
      executors={[
        { executor: drupalExecutor(`/graphql`) },
        { executor: data, id: FrameQuery },
        {
          executor: allAccommodationAttributes,
          id: AllAccommodationAttributesQuery,
        },
        {
          executor: allAccommodationTypeTerms,
          id: AllAccommodationTypeTermsQuery,
        },
        { executor: allCampsites, id: AllCampsitesQuery },
        { executor: allCampsiteFeatures, id: AllCampsiteFeaturesQuery },
        {
          executor: accommodationSearchExecutor(apiKey),
          id: AccommodationSearchQuery,
        },
        { executor: allCampsitesRegions, id: AllCampsiteRegionsQuery },
        { executor: searchPageSettings, id: SearchPageSettingsQuery },
      ]}
    >
      <Frame>{children}</Frame>
    </OperationExecutorsProvider>
  );
}
